<template>
  <div class="dashboard-grid">
    <div class="box green">
      <img
        class="align-self-center mx-2 status-icon"
        src="@/assets/images/status-tick.svg"
        alt=""
      />
      <div class="status-label">Patient Website</div>
    </div>
    <div class="box green">
      <img
        class="align-self-center mx-2 status-icon"
        src="@/assets/images/status-tick.svg"
        alt=""
      />
      <div class="status-label">Staff Portal</div>
    </div>
    <div class="box green">
      <img
        class="align-self-center mx-2 status-icon"
        src="@/assets/images/status-tick.svg"
        alt=""
      />
      <div class="status-label">Online Forms</div>
    </div>

    <div class="box red">
      <img
        class="align-self-center mx-2 status-icon"
        src="@/assets/images/status_fail.svg"
        alt=""
      />
      <div class="status-label">Server Load</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardGrid",
};
</script>

<style scoped>
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  width: 100%;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 146px;
  color: white;
  font-size: 14px;
  border-radius: 0px;
  text-align: left;
  padding: 20px;
}

.green {
  background-color: #07752b;
}

.red {
  background-color: #d84730;
}

.check-icon,
.warning-icon {
  font-size: 24px;
  margin-bottom: 10px;
}
.status-icon {
  padding: 10px;
  align-items: baseline;
  position: relative;
  right: 40px;
  bottom: 10px;
}
.status-label {
  position: relative;
  bottom: 10px;
  max-width: 50%;
}
</style>
